import React, {
  useRef,
  useState,
} from 'react';

import PropTypes from 'prop-types';

import Arrow from 'shared-vectors/icons/DsChevron16';
import { Icon } from 'shared-vectors';

import { useCtxGlobal } from '@client/app/Container';

import Card from '@components/searchPage/results/Card';

import './style.scss';

const CardsReel = ({
  data,
  viewport,
  isDesktop,
  hasSlider,
  setCurrentFloorplan,
  loadDetail,
}) => {
  const {
    isMobile,
    isSmallMobile,
    iosLth12,
    globalSelector,
    globalReducer,
    globalState: {
      favorites,
      searchIsSaved,
      config: {
        cookiesConfig = {},
        api: {
          account,
          authBasePrefix,
          portal26,
        },
      } = {},
    } = {},
    model: {
      total,
      pageUrls,
    },
    user,
    logIn,
    showSynchingDialog,
    openModal,
    closeModal,
    siteUrl,
    filtersProps,
    filtersProps: {
      device,
      locations,
      filters,
    },
    userConf: {
      userUrls: {
        userhost,
      },
    },
    pageType,
    setNewSearchFromSaveSearchModal,
    getUser,
    getUserLoginPayload,
    updateUserFormData,
    saveBookmarkSuccess,
  } = useCtxGlobal();

  const cardProps = {
    device: 'smartphone',
    isSixth: false,
    isMobile: true,
    maplist: true,
    mapcard: true,
    forceVisible: true,
    isPublisherHp: false,
    isPublisherPage: false,

    realDevice: device,
    realIsMobile: isMobile,

    filters,
    locations,
    isSmallMobile,
    iosLth12,
    cookiesConfig,
    account,
    authBasePrefix,
    siteUrl,
    filtersProps,
    userhost,  
    user,
    pageType,
    favorites,
    total,
    logIn,
    openModal,
    closeModal,
    showSynchingDialog,
    globalReducer,
    globalSelector,
    getUser,
    getUserLoginPayload,
    updateUserFormData,
    saveBookmarkSuccess,
    setNewSearchFromSaveSearchModal,
    searchIsSaved,
    pageUrls,
  };

  const cardWidth = useRef(isDesktop ? 284 : document.documentElement.clientWidth - 48);
  const sliderWidth = useRef((data.length * (cardWidth.current + 8)) - 8);

  const slider = useRef(null);
  const touchStart = useRef(null);
  const touchDelta = useRef(null);
  const touchDirection = useRef(null);

  const [sliderState, setSliderState] = useState({
    current: 0,
    coords: 0,
  });

  const prev = () => {
    if (sliderState.current > 0) {
      const newCurrent = sliderState.current - 1;
      setSliderState({
        current: newCurrent,
        coords: (cardWidth.current + 8) * newCurrent,
      });
    }
  };

  const next = () => {
    if (sliderState.current < data.length - 1) {
      const newCurrent = sliderState.current + 1;
      setSliderState({
        current: newCurrent,
        coords: (cardWidth.current + 8) * newCurrent,
      });      
    }
  };

  const handleTouchStart = (e) => {
    if (e.target.nodeName === 'IMG' && e.target.parentNode.classList.contains('csaSrpcard__gal__slider__imgcont')) {
      return null;
    }
    slider.current.classList.add('no-anim');
    const [touches] = e.touches;
    touchStart.current = touches.clientX;
  };

  const handleTouchMove = (e) => {
    if (touchStart.current) {
      const [touches] = e.touches;
      touchDelta.current = touches.clientX - touchStart.current;
      touchDirection.current = touchDelta.current < 0 ? 'next' : 'prev';
      const move = touchDelta.current + (cardWidth.current + 8) * sliderState.current * -1;
      if (touchDirection.current === 'prev' && sliderState.current > 0 || touchDirection.current === 'next' && sliderState.current < data.length - 1) {
        slider.current.style.transform = `translate3d(${move}px, 0, 0)`;
      } 
    }
  };

  const handleTouchEnd = () => {
    slider.current.classList.remove('no-anim');
    if (Math.abs(touchDelta.current) > cardWidth.current / 4) {
      if (touchDirection.current === 'next') {
        next();
      } else {
        prev();
      }
    } else {
      slider.current.style.transform = `translate3d(${sliderState.coords * -1}px, 0, 0)`;
    }
    touchStart.current = null;
    touchDelta.current = null;
    touchDirection.current = null;
  };

  return (
    <>
      {hasSlider ? (
        <div className="csa_cardsreel__nvr mb--m">
          <div className="csa_cardsreel__nvr__cnt c-bg--w pt--xs pb--xs pr--ms pl--ms">
            <p className="tp-s--m tp-w--s c-txt--f0">
              <span className="tp-w--m">{sliderState.current + 1}</span> di {data.length} a quest&apos;indirizzo
            </p>
            <div className={`ml--xs c-txt--${sliderState.current === 0 ? 'border' : 'f0 is-clickable'}`} onClick={prev}>
              <Icon name={Arrow} className="is-rot-180" fill />
            </div>
            <div className={`ml--xs c-txt--${sliderState.current === data.length - 1 ? 'border' : 'f0 is-clickable'}`} onClick={next}>
              <Icon name={Arrow} fill />
            </div>            
          </div>
        </div>
      ) : null}
      <div className="csa_cardsreel is-rel">
        <div
          ref={slider}
          className="csa_cardsreel__sldr"
          style={{ width: sliderWidth.current, transform: `translate3d(-${sliderState.coords}px, 0, 0)` }}
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
        >
          {data.map((article, index) => (
            <div key={article.id} className={index > 0 ? 'ml--s' : ''}>
              <Card
                article={article}
                isFetching={false}
                setCurrentFloorplan={setCurrentFloorplan}
                loadDetail={loadDetail}
                collapseMandateBanner={null}
                viewport={viewport}
                portal26Domain={portal26}
                {...cardProps}
              />
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default CardsReel;

CardsReel.propTypes = {
  data: PropTypes.instanceOf(Array),
  viewport: PropTypes.instanceOf(Object),
  isDesktop: PropTypes.bool,
  hasSlider: PropTypes.number,
  setCurrentFloorplan: PropTypes.func,
  loadDetail: PropTypes.func,
};

CardsReel.defaultProps = {
  data: [],
  viewport: {},
  isDesktop: false,
  hasSlider: 0,
  setCurrentFloorplan: () => {},
  loadDetail: () => {},
};
